import { useRecoilValue } from "recoil";
import { LocaleAtom } from "../../../../state/localeAtom";

type TourStepContentProps = {
	description: React.ReactNode | (() => React.ReactNode);
};

const TourStepContent = ({ description }: TourStepContentProps) => {
	// Subscribe to locale so this component re-renders when language changes.
	// Descriptions passed as thunks () => node are re-evaluated on each render,
	// allowing text getters to pick up the new locale.
	useRecoilValue(LocaleAtom);

	const content = typeof description === "function" ? description() : description;

	return (
		<div>
			<div>{content}</div>
		</div>
	);
};

export default TourStepContent;
